import { AbstractLocalStorage } from "./AbstractLocalStorage";

import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("LocalStorage.MemoryStorage");

/**
 * Wrapper to access storage data from memory.
 */
export class MemoryStorage extends AbstractLocalStorage {
    /**
     * Read data from memory using current section.
     */
    public read(): Promise<any> {
        logger.warn("using memory as fail back, no data will be persisted.");

        this._data = {};
        return Promise.resolve(this._data);
    }

    /**
     * Keep data on memory, no data will be persisted.
     */
    public write(): void {
        logger.warn("keeping data on memory as fail back, no data will be persisted.");
        return;
    }
}
